import request from '@/utils/request'

// 查看计划结果
 export function apiFindPagePlanResultList (query) {
    return request({
      url: `/scp/scpMpsPlans/findPagePlanResult`,
      method: 'get',
      params: query
    })
  }
